import { createContext } from "react";

interface HoopsViewerContextType {
  fileVersionId: string;
  viewerImpl: any;
  isModelStructureReady: boolean;
  isSettingsApplied: boolean;
}

export const HoopsViewerContext = createContext<HoopsViewerContextType | null>({
  fileVersionId: "",
  viewerImpl: null,
  isModelStructureReady: false,
  isSettingsApplied: false,
});
